import { IStatus, StatusPicker } from '@dfl/mui-react-common';
import { useState } from 'react';
import {
  TRACKING_OPTIONS,
  TRACKING_OPTIONS_MAP,
} from 'modules/sales/settings/order-status/settings/tracking-picker-settings';
import { UseMutateFunction } from '@tanstack/react-query';
import { ConfirmRowAction } from '@dfl/mui-admin-layout';
import { useToggle } from '@dfl/hook-utils';
import { useTranslation } from 'react-i18next';
import { Box, Stack } from '@mui/material';

type TrackingStatusPickerProps = {
  value: boolean;
  isLoading: boolean;
  handleChange: UseMutateFunction<any>;
};

const TrackingStatusPicker = ({ value, isLoading, handleChange }: TrackingStatusPickerProps) => {
  const { isOpen, onClose, onOpen } = useToggle();
  const [currentValue, setCurrentValue] = useState(value);
  const { t } = useTranslation('common');

  const handleClose = () => {
    setCurrentValue(value);
    onClose();
  };

  const handleOpen = () => {
    setCurrentValue(!value);
    onOpen();
  };

  const handleChangeAction = () => {
    handleChange();
    onClose();
  };

  const trackingStatus = TRACKING_OPTIONS_MAP(t).get(currentValue) as IStatus;

  return (
    <>
      <Stack
        direction={'row'}
        sx={{
          alignItems: 'center',
          '.MuiButton-root': {
            whiteSpace: 'nowrap',
          },
        }}
      >
        <StatusPicker
          options={TRACKING_OPTIONS(t)}
          name='active'
          size={'small'}
          value={trackingStatus}
          isLoading={isLoading}
          onChange={handleOpen}
        />
      </Stack>
      <Box sx={{ display: 'none' }}>
        <ConfirmRowAction
          isOpen={isOpen}
          onClose={handleClose}
          onOpen={onOpen}
          onConfirm={handleChangeAction}
          isLoading={isLoading}
          confirmationTitle={t('confirmation.title')}
          confirmationMessage={t('confirmation.description')}
          confirmButtonText={t('confirmation.confirm')}
        />
      </Box>
    </>
  );
};
export default TrackingStatusPicker;
